import { jsx as o } from "react/jsx-runtime";
const t = (r) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...r,
    children: /* @__PURE__ */ o(
      "path",
      {
        stroke: "currentcolor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M5 12h14M5 12l4 4m-4-4 4-4"
      }
    )
  }
);
export {
  t as default
};
